import { MakeMangedRequestOptions } from '~/networking/client/VinovestNetworkingClient';
import { httpRequest, Response } from '~/networking/utils/httpRequest';

export interface NewTradeListing {
    productId: number;
    price: {
        amount: number;
        currency: string;
    };
    minPrice?: {
        amount: number;
        currency: string;
    } | null;
    fmvPeg?: boolean;
    quantity: number;
}

/**
 * similar to createOfferListing, but can create multiple offers at once (quantity)
 * and the tradeId doesn't have to be known ahead of time
 *
 * this endpoint is meant for the marketplace and may have different behavior than the offer listing endpoint
 */
export const createTradingListing =
    ({ getHeaders, getRequestUrl, getPortfolioId }: MakeMangedRequestOptions) =>
    async (newOffer: NewTradeListing): Promise<Response<{} | { message: string }>> => {
        const headers = getHeaders(true);
        const createNewOfferEndpoint = getRequestUrl(`/v1/markets/portfolio/${getPortfolioId()}/offers`);
        return httpRequest.post(createNewOfferEndpoint, { body: newOffer, headers });
    };
